<template>
  <div class="evaluation-question">
    <div
      class="helper"
      v-if="item.helper !== ''">
      <el-popover
        placement="top-start"
        width="400"
        trigger="hover">
        <div v-html="item.helper"/>
        <el-button
          slot="reference"
          icon="el-icon-question"
          circle/>
      </el-popover>
    </div>
    <header>
      <div class="index-wrapper">
        <span class="index">{{ currentIndex }}</span>
      </div>
      <div class="title-wrapper">
        <h3>{{ item.name }}</h3>
      </div>
    </header>
    <main>
      <div class="question-wrapper">
        <div
          class="description"
          v-html="item.description"
        />
        <evaluation-answer
          :branch-type="branchType"
          :question="item"/>
        <div class="evidence-controls">
          <p v-if="item.evidenceRequired || item.innerEvidenceRequired"><b>¡Importante!</b> Se necesita presentar
          evidencia para validar este punto.</p>
          <el-badge
            is-dot
            class="item"
            :hidden="!item.comment"
          >
            <button
              @click="$emit('comment', item)"
              title="Agregar comentario">
              <i class="icon-message-square"/>
            </button>
          </el-badge>
          <el-badge
            is-dot
            class="item"
            :hidden="!item.evidence || !item.evidence.length"
          >
            <button
              title="Agregar adjuntos"
              @click="$emit('evidence', item)"
            >
              <i class="icon-attach_file"/>
            </button>
          </el-badge>
        </div>
        <div
          v-if="item.evidence && item.evidence.length"
          class="evidences"
        >
          <table class="ms-grid">
            <thead>
              <tr>
                <th class="text-left">
                  Archivo
                </th>
                <th class="text-right">
                  Acción
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(evidence, $index) in item.evidence"
                :key="$index"
              >
                <td>
                  {{ evidence.name || evidence.data.name }}
                </td>
                <td class="text-right">
                  <button
                    class="el-button el-button--text"
                    @click="deleteEvidence(evidence.id, $index)">
                    <i class="icon-trash"/>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>

  </div>
</template>

////////////////////////////
//                   SCRIPT
////////////////////////////
<script>
import EvaluationAnswer from '@/modules/evaluation/components/layout/evaluation-answer'
import http from '@/services/http.service'

export default {
  name: 'EvaluationQuestion',
  components: { EvaluationAnswer },
  props: {
    index: {
      type: Array,
      default () {
        return []
      }
    },
    item: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    },
    branchType: {
      type: String,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    currentIndex () {
      let result = ''
      for (let i = 0; i < this.index.length; i++) {
        result += this.index[i] + 1 + '.'
      }
      return result.slice(0, -1)
    }
  },
  methods: {
    deleteEvidence (id, index) {
      http.delete('evidences/' + id).then(response => {
        this.item.evidence.splice(index, 1)
        this.$message.success('Evidencia eliminada con éxito')
      })
    }
  }
}
</script>

////////////////////////////
//                    STYLE
////////////////////////////
<style
  lang="scss"
  scoped
>
.ms-grid {
  width: 100%;
}

.evaluation-question {
  padding: 40px;
  position: relative;
  .helper {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  header {
    display: flex;
    .index-wrapper {
      width: 60px;
      float: left;
      .index {
        @include font-primary(12px, bold);
        display: inline-block;
        background-color: $color-ui-primary;
        color: #fff;
        box-shadow: 0 3px 3px rgba(0, 0, 0, 0.2);
        padding: 5px;
        min-width: 14px;
        text-align: center;
        border-radius: 2px;
        vertical-align: middle;
      }
    }
    .title-wrapper {
      flex-grow: 1;
      h3 {
        @include font-primary(14px, semibold);
        color: #444444;
        margin: 0;
      }
      .description * {
        font-size: 12px !important;
        color: #666666 !important;
      }
    }
  }
  main {
    margin-left: 60px;
    .evidence-controls {
      padding: 20px 0;
      button {
        font-size: 16px;
        background-color: #f6f6f6;
        border-radius: 4px;
        color: #999999;
        border: none;
        width: 40px;
        height: 40px;
        &:active {
          background-color: #cdcdcd;
        }
        &:focus {
          outline-color: #cb7a6f;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/evaluation/components/layout/evaluation-question.vue